// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"790":"88e0bea4","978":"0c39f29a"}[chunkId] + ".chunk.css";
};